import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
} from "@angular/core";
import { RenderedService } from "../../rendered.service";
import { BaseScaffoldComponent } from "../base-scaffold/base-scaffold.component";
import { ItemsService } from "../../../../services/items.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "scaffold-select",
  templateUrl: "./select.component.html",
  styleUrls: ["../../rendered.component.scss", "./select.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectComponent
  extends BaseScaffoldComponent
  implements OnInit, OnDestroy
{
  @Output() change = new EventEmitter<any>();
  public destroy$: Subject<boolean> = new Subject<boolean>();
  selectedValue;
  options;
  watch_value;
  last_keys = [];
  constructor(
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService,
    private itemsService: ItemsService
  ) {
    super(cdr, renderedService);
  }

  ngOnInit() {
    this.renderedService
      .listenForUpdates()
      .pipe(takeUntil(this.destroy$))
      .subscribe((trigger) => {
        this.cdr.detectChanges(); //template_name
      });
    this.options = this.item.options;
    if (this.item.template_select) {
      this.itemsService
        .registerItem(this.info)
        .pipe(takeUntil(this.destroy$))
        .subscribe((d) => {
          console.log("subscription");
          if (this.itemsService.hasKey(d, this.item.template_name)) {
            let value = d[this.item.template_name];
            console.log("Template vlaue updated");
            console.log(value);
            if (value && value.match) this.processTemplateValue(value);
          }
        });
      let value = this.itemsService.get(
        this.itemsService.getData(this.info),
        this.item.template_name
      );
      console.log(value);
      if (value && value.match) this.processTemplateValue(value);
    }

    this.update();
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
  updateSelect() {
    this.change.emit({ value: this.selectedValue });
  }

  processTemplateValue(value) {
    if (this.watch_value != value) {
      this.watch_value = value;
      let keys = value.match(/\[[^\]]+\]/g);
      console.log(keys, this.last_keys);
      if (keys && JSON.stringify(this.last_keys) != JSON.stringify(keys)) {
        //prevent calculating the new tempate keys if they havent changes when the text is updated
        this.last_keys = keys;
        this.options = keys.map((k) => {
          let key = k.replace(/[\[,\]]/g, "");
          return { label: key, value: key };
        });
        this.update();
      }
    }
  }

  update() {
    this.selectedValue = this.value;
    this.cdr.detectChanges();
  }
}
